module.exports = {
  siteTitle: 'Portal del Registro Civil',
  siteDescription: 'Bienvenidos al Portal del Registro Civil de San Luis',
  authorName: '',
  //links path for request
  loginCasilleroUrl: '',
  rcName: 'RC_Blanco',
  
  pathPrefix: '',
  googleMapsUrl: 'https://www.google.com/maps/place/',

  //images in general
  siteCover: 'sitecover', // file in content/images
  siteFooter: 'footer',
  siteheader: 'header',

  //END_POINT: 'http://localhost:8080/civilregistrationServer/', //Devs
  END_POINT: 'https://registrocivilsanluis.sanluis.gob.ar:8443/civilregistrationServer/', //Prod
  //END_POINT: 'http://201.222.57.18:8080/civilRegistrationAppointmentServer/', //Ministerio
   //END_POINT: 'https://testrc.sanluis.gob.ar:8443/civilregistrationServer/', //Testing
  
   getShiftLink: 'https://registrocivilsanluis.sanluis.gob.ar/turnos/#/pages/appointment-form', //Prod
  // getShiftLink: 'http://201.222.57.18:8890/turnos/#/pages/appointment-form', //Ministerio
   //getShiftLink: 'https://testrc.sanluis.gob.ar:449/#/pages/appointment-form', //Testing
   //getShiftLink: 'http://localhost:4205/turnos/#/pages/appointment-form', //Devs
  
  background_color: '#ffffff',
  theme_color: '#000000',
  display: 'standalone',
  icon: '',
  postsPerPage: 6,
  disqusShortname: 'maxpou',
  headerTitle: 'Registro Civil',
  headerLinksIcon: '', 

}
